export type PanelCloseReason='replace'|'escape'|'close'|'outside'|'destroy';
export class HudPanels {
 private readonly dismiss=new Map<string,(reason:PanelCloseReason)=>void>();
 register(id:string,close:(reason:PanelCloseReason)=>void):()=>void {
  this.dismiss.set(id,close);
  return ()=>{if(this.dismiss.get(id)===close)this.dismiss.delete(id);};
 }
 open(id:string):void {
  this.resetInput();
  for(const [other,close] of this.dismiss)if(other!==id)close('replace');
 }
 close(id:string,reason:PanelCloseReason='close'):void {this.resetInput();this.dismiss.get(id)?.(reason);}
 private resetInput():void {if(typeof window!=='undefined')window.dispatchEvent(new Event('gameplay-input-reset'));}
}
export const hudPanels=new HudPanels();
